import connectionsService from '../services';
import { ConnectionError } from '../types/connection-types';
import {
  clearErrorMessage,
  setConnections,
  setErrorMessage,
  setLoadingConnections,
} from '../utils/connections-store-utils';

export const loadConnections = async (): Promise<void> => {
  try {
    setLoadingConnections(true);
    clearErrorMessage();

    const connections = await connectionsService.getConnections.execute();
    if (!connections) {
      setErrorMessage(ConnectionError.FailedLoadConnections);
      return;
    }

    setConnections(connections);
  } finally {
    setLoadingConnections(false);
  }
};
